<template>
	<div class="shippedtracking">
	<span style="display:none;"> {{awb_code}}
	{{srToken}}
	{{orderId}} {{currentshipment_status}}</span>
	<!--{{shipmenttrackactivities}} -->
	
   <!-- {{shipment_id}}---
    {{shipment_order_id}}---
    {{shippingBy}}---
    {{'awbCode'+awbCode}}- -->
    
	<b-link :href="'https://app.shiprocket.in/tracking/awb/'+awb_code" target="_blank">Track Your Order</b-link>
	
		<!-- <div class="p-xl mh-lg tracking-steps ng-scope" ng-if="showTrack === 1" style="">
         <div class="tracking-block">
            <ul class="mv-xl p0 text-left">
               <li>

                  <span class="dot shipped p-lg mb-sm active gbg" ng-class="{'active':shipped}">
                     <i class="fa fa-rocket fa-lg"></i>
                     
                  </span>
                  <span class="strip1"></span>
                  <span class="strip active gbg" ng-class="{'active':inTrisit}"></span>
                  <div style="margin-left: -15px;" class="arrow_box mb">Shipped</div>

               </li>
               <li>

                  <span class="dot transit p-lg mb-sm active gbg" style="margin-left: -4px;" ng-class="{'active':inTrisit}">
                     <i class="fa fa-tasks fa-lg"></i>
                    
                  </span>
                  <span class="strip1"></span>
                  <span class="strip2 active0 gbg" ng-class="{'active0':outForDelivery}"></span>
                  <div style="margin-left: -20px;" class="arrow_box mb">In Transit</div>
               </li>

               <li>

                  <span class="dot ofd p-lg mb-sm active gbg" style="margin-left: -4px;" ng-class="{'active':outForDelivery}">
                     <i class="fa fa-truck fa-flip-horizontal fa-lg"></i>
                     
                  </span>
                  <span class="strip1"></span>
                  <span class="strip3 active0 gbg" ng-class="{'active0':delivered}"></span>
                  <div style="margin-left: -20px;" class="arrow_box mb ng-binding">Out for Delivery</div>
               </li>

               <li style="width:0%;">

                  <span class="dot delivered p-lg mb-sm active gbg" style="margin-left: -19px;" ng-class="{'active':delivered}">
                     <i class="fa fa-check-square-o fa-lg"></i>
                    
                  </span>
                  <div class="arrow_box mb" style="right: 3px;">Delivered</div>
               </li>
            </ul>
         </div>

      </div> -->
		<b-row>
		<b-col class="ml-15">
		 <div class="mailer-block text-center bg-white mb-xl block-center">
		  <!-- <h4 class="m0 pv text-normal ph-lg text-left ng-binding">Tracking Update for 1091164055473</h4> -->
		  <!-- ngIf: showTrack === 1 --><div class="p-xl mh-lg tracking-steps ng-scope" ng-if="showTrack === 1" style="">
			 <div class="tracking-block">
				<ul class="mv-xl p0 text-left">
				   <li>

					  <span class="dot shipped p-lg mb-sm " :class="{'gbg':shippedCon}" > 
						<!-- v-bind:class="[{ active: isActive }, errorClass]" -->
						 <i class="fa fa-rocket fa-lg"></i>
						 <!-- <i class="fa fa-check fa-lg"></i> -->
					  </span>
					  <span class="strip1"></span>
					  <span class="strip" :class="{'gbg':inTrisit}" ng-class="{'active':inTrisit}"></span>
					  <div style="margin-left: -15px;" class="arrow_box mb">Shipped</div>

				   </li>
				   <li>

					  <span class="dot transit p-lg mb-sm" style="margin-left: -4px;" :class="{'gbg':inTrisit}" ng-class="{'active':inTrisit}">
						 <i class="fa fa-tasks fa-lg"></i>
						 <!-- <i class="fa fa-check fa-lg"></i> -->
					  </span>
					  <span class="strip1"></span>
					  <span class="strip2" :class="{'gbg':outForDelivery}" ng-class="{'active0':outForDelivery}"></span>
					  <div style="margin-left: -20px;" class="arrow_box mb">In Transit</div>
				   </li>

				   <li>

					  <span class="dot ofd p-lg mb-sm" style="margin-left: -4px;" :class="{'gbg':outForDelivery}" ng-class="{'active':outForDelivery}">
						 <i class="fa fa-truck fa-flip-horizontal fa-lg"></i>
						 <!-- <i class="fa fa-check fa-lg"></i> -->
					  </span>
					  <span class="strip1"></span>
					  <span class="strip3" :class="{'gbg':delivered}" ng-class="{'active0':delivered}"></span>
					  <div style="margin-left: -20px;" class="arrow_box mb ng-binding">Out for Delivery</div>
				   </li>

				   <li style="width:0%;">

					  <span class="dot delivered p-lg mb-sm " style="margin-left: -19px;" :class="{'gbg':delivered}"  ng-class="{'active':delivered}">
						 <i class="fa fa-check-square-o fa-lg"></i>
						 <!-- <i class="fa fa-check fa-lg"></i> gbg -->
					  </span>
					  <div class="arrow_box mb" style="right: 3px;">Delivered</div>
				   </li>
				</ul>
			 </div>

		  </div><!-- end ngIf: showTrack === 1 -->
		  <!-- ngIf: showTrack === 2 -->
	   </div>
	   </b-col>
	   </b-row>
	   							<b-row class="mt-1 px-3">
								<b-col   class="text-left p-0 scrollDiv">
									<b-table-simple  small caption-top responsive>
										<!--<caption></caption>-->
										<b-thead head-variant="light">
											<b-tr>
												<b-th >Location</b-th>
												<b-th >Date</b-th>
												<b-th >Activity</b-th>
											</b-tr>
										</b-thead> 
										<b-tbody>
											<b-tr v-for="itemTin in shipmenttrackactivities" :key="itemTin.date">
												<b-th style="font-weight:400;"> {{itemTin.activity}}</b-th>
												<b-th style="font-weight:400;">{{itemTin.date}}</b-th>
												<b-th style="font-weight:400;">{{itemTin.activity}}</b-th>										
											</b-tr>
											
											
											
									   </b-tbody>
									   
									</b-table-simple>
								</b-col>
										
							</b-row>

	
	</div> 
</template>

<script>
	import '@/assets/shippingtrack.scss';


export default {
  name: "ProductPrice",
  props: {
    awb_code:{ type: String},
    shipment_id:{ type: Number },
    shipment_order_id:{ type: Number},
    shippingBy:{ type: String},
    srToken:{type:String},
    orderId:{type:String},
    shipmenttrackactivities:{type:Array},
    currentshipment_status:{type:Number},
   
  },
  mounted(){
    this.inLoddata();
	/*var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	} */
  },
  updated(){
    this.inLoddata();
	
  },
  data(){
    return {
      product_qty:1,
      special_price:100,
      price:200,
	  awbCode:this.awb_code,
	  iframe: {
		src: window.location.href,
		style: null,
		wrapperStyle: null,
		},
		updateAutoSRUrl: this.$root.WEBAPI+'sellerapi/srOrderUpdateAuto',
		orderDetailUrl: this.$root.WEBURL+'getOrderDetailByOid',
		isBggreen:'',
		shippedCon:0,
		inTrisit:0,
		outForDelivery:0,
		delivered:0,
		
	 
    }
  },
  methods:{
	inLoddata(){
		console.log('dasd'+this.awb_code);
			var self = this;
		  //var awb = '19041194396192';
		  var awb = self.awb_code;
		  //var awb = '19041213497184';
			   //var shipment_id = '139321670';
			  // var addressList ={awbs:[awb]};
			//  console.log(addressList+'--'+shipment_id);
			  self.axios({
					//url: "https://apiv2.shiprocket.in/v1/external/courier/track/shipment/"+shipment_id,
					url: "https://apiv2.shiprocket.in/v1/external/courier/track/awb/"+awb,
					//url: "https://apiv2.shiprocket.in/v1/external/courier/track/awbs",
					method: 'GET',
					headers: {"Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
					//data:addressList 
					})
				  .then(res => {
					//console.log(`Axios Call completed: ${res}`);
					
					//var tracking_data = res.tracking_data;
					//console.log(tracking_data);
					//console.log(tracking_data.track_status);
					
					var dataResult = res.data.tracking_data;
					//console.log('dataResult:'+dataResult);
					//console.log('dataResult:'+JSON.stringify(dataResult));
					var track_status = dataResult.track_status;
					var shipment_status = dataResult.shipment_status;
					var etd = dataResult.etd;
					var track_url = dataResult.track_url;
					var shipment_track_activities = dataResult.shipment_track_activities;
					console.log(track_status+'--'+shipment_status+'--'+etd+'--'+track_url+'--'+shipment_track_activities);
					/* --------  Update  shipping  ---------- */
					
					var shipmentStatus = self.currentshipment_status
					console.log('shipmentStatus:'+shipmentStatus);
					if(shipmentStatus==6){
						self.shippedCon=1;
					}else if(shipmentStatus==7){
							self.shippedCon=1;
							self.inTrisit=1;
							self.outForDelivery=1;
							self.delivered=1;
					
						
					}else if(shipmentStatus==8){
						//sqlquery.delivery_status = 'order_cancelled';
						//sqlquery.order_status = 'completed';
						
					}else if(shipmentStatus==18){
						//sqlquery.delivery_status = 'in_transit';
						
						self.shippedCon=1;
						self.inTrisit=1;
						self.outForDelivery=0;
						self.delivered=0;
					}else if(shipmentStatus==17){
						//sqlquery.delivery_status = 'out_for_delivery';
						self.shippedCon=1;
						self.inTrisit=1;
						self.outForDelivery=1;
						self.delivered=0;
						
						
					}else{
						
						console.log('vijayOU');
					}
					
					
					if(self.currentshipment_status!=shipment_status){
						if(shipment_track_activities!=''){
							self.shipmenttrackactivities=shipment_track_activities;
								//shipment_track_activities
				
				
							self.axios.post(self.updateAutoSRUrl, {
								accesskey: self.$session.get('access_key'),
								shipment_track_activities: shipment_track_activities,
								orderId:self.orderId,
								track_status:track_status,
								shipment_status:shipment_status,
								
							})
							.then(function (response) {
								if(response.data.error == 0 || response.data.error == '0'){
								
									console.log(response.data.message);
									/*self.$bvModal.hide('my-model');
									self.$bvToast.toast(response.data.message, {
										title: 'Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'warning',
										solid: true,
										appendToast: true
									});
									self.initload(); */
								}
								
							})
							.catch(function (error) {
								alert(error);
							});
								
								
						}
					}
					//var track_status =
					
					
				  }); 
				  
				  
				/*curl --location --request POST 'https://apiv2.shiprocket.in/v1/external/courier/track/awbs' \
				--header 'Content-Type: application/json' \
				--header 'Authorization: Bearer {{token}}' \
				--data-raw '{
				"awbs": ["788830567028","788829354408"]
				}'*/
		
		
		
	},clickme(){
		alert('dasd'+this.awb_code);
	},
  }
};
</script>
<!-- scoped -->
<style  lang="scss">
.shippedtracking{
	background-color:#fff;
	
	
	/*.tracking-steps ul li {
			width: 28%!important;
		}*/

}
/*.tracking-steps ul li {
			width: 25%!important;
			display:inline-table;
		}
		
	.tracking-steps ul li .dot {
    background-color: #999;
    border-radius: 50px;
    display: inline-block;
    height: 50px;
    width: 50px;
    z-index: 1;
    position: relative;
}
.fa-lg {
    font-size: 1.33333333em;
    line-height: .75em;
    vertical-align: -15%;
}

.strip1, .strip2, .strip3 {
    background-color: #c3c3c3;
    display: inline-block;
    height: 5px;
    width: 100%;
    left: 0;
    bottom: 23%;
    position: absolute;
}

.tracking-steps ul li .strip {
    background-color: #c3c3c3;
    display: inline-block;
    height: 5px;
    width: 100%;
    left: 0;
    bottom: 23%;
    position: absolute;
}



.gbg {
    background-color: #7AB43C!important;
}

.tracking-steps ul li .arrow_box {
    margin-left: -31px;
    position: relative;
    background: #fff;
    border: 1px solid #999;
    width: 80px;
    text-align: center;
    font-size: 13px;
    padding: 2px 0 3px;
    border-radius: 3px;
	z-index: 999;
}


.tracking-steps > .tracking-block > ul.mv-xl.p0.text-left li:nth-child(1) > div.arrow_box.mb {
    margin-left: -50px!important;
    
	
}

.tracking-steps > .tracking-block > ul.mv-xl.p0.text-left li:nth-child(3) > div.arrow_box.mb {
    margin-left: -40px!important;
    width: 120px;

} */


</style>